import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage38.module.css"
import { Link } from '@mui/material'

export default function LaymanPage38() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF CAPRICORN</h1>
                  </div>
                </div>
              </div>
            </div>



            <div className={styles.common_width}>
              <div className={styles.om_block_main}>
                <div
                  className={`${styles.om_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/capricorn/capricorn_1img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/capricorn/capricorn_1img.webp`}/> 

                  </div>
                  {/* className={styles.yellow_txt} */}
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>The Earthly Symphony of Capricorn: Embracing Fearlessness
                          and the Erotic Impulse</h2>
                      </div>
                      <p>
                        In the tapestry of <Link href="https://www.divineinfinitebeing.com">Divine Infinite Being</Link> and Archetypal Astrology, Capricorn emerges as a cosmic archetype, a cardinal earth influence that beckons us to the mythical depths of the earth. This powerful being, symbolized by the goat, carries with it the echoes of ancient myths, the enchanting music of Pan's flute, and the indomitable spirit of Prometheus.

                      </p>
                      <p><b>Pan's Flute and the Earthly Depths:</b></p>
                      <p>Capricorn, as a cardinal earth influence, resonates with the musical flute of Pan, drawing us into the mysterious realms of the earth. It leads us into enchanted forests where magic and the risk of death coexist. In these depths, the archetype of Capricorn is charged with vigor and uninhibited sexuality, embodying the male erotic impulse and the youthful energy of courtship.</p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Symbolic Essence of OM:</h2>
                      </div> */}
                      <p><b>The Goat atop the Mountain:</b></p>
                      <p>
                        In the symbolic realm, Capricorn, the goat, is a creature thriving at the summit of mountains,
                        defiant against the elements. This creature requires very little but symbolizes endless
                        industriousness. It mirrors the vigor of the entrepreneur, someone who can build an empire from nothing, driven by the grit of intent. Fearless and powerful, Capricorn embodies the archetype of the Devil, full of erotic power that loosens inhibitions and drives us into the ecstasy of existence.
                      </p>


                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/capricorn/capricorn_2img.webp"/> */}
                     <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/capricorn/capricorn_2img.webp`}/> 
                  </div>


                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Vibration and Chanting:</h2>
                      </div> */}
                      <p><b>Prometheus and the Devil's Dance:</b></p>
                      <p>
                        Capricorn, as Prometheus and the Devil, builds towards a return to the realm of the gods. The Devil, with its imaginal eye, sees the chaos of life beyond boundaries and welcomes its influence. This archetype is the initiator, bringing the fire of the gods to earth. Frenzied orgies dedicated to
                        Dionysus, the Ancient Thracians' deity, find their roots in the passionate energy of Capricorn.
                        Similarly, the tireless expressions of progress in all its forms are manifestations of this
                        earthy force.

                      </p>
                      <p><b>Living Under Capricorn's Influence:</b></p>

                      <p>
                        To work under the influence of Capricorn is to embrace fearlessness, to venture into the unknown without doubt.  is to open up to our sexuality and express our inner natures uninhibited, both physically and creatively through our work. It Capricorn calls us to revel in the mysteries of the earth, to bring the strangeness and novelty of our becoming into the imaginative realm. It is an invitation to live at the peak of our potential, to build empires with determination, and to dance with the devil, unafraid of the chaos that life may offer.
                      </p>
                      <p>
                        In the symphony of cosmic archetypes, Capricorn stands as a powerful force, urging us to ascend mountains, embrace our erotic impulses, and, in the dance of Prometheus, strive for a return to the divine. It is an earthly symphony that resonates with fearlessness, passion, and the relentless
                        pursuit of progress.
                      </p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div> */}



                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/capricorn/capricorn_3img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/capricorn/capricorn_3img.webp`}/> 

                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>

                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <p>
                        <b>Archetype:</b> Capricorn represents the Cardinal Earth Influence in astrological archetypes.

                      </p>

                      <p>

                        <b>Symbolic Goat:</b> The goat is a potent symbol embodying resilience, determination, and the
                        ability to thrive in challenging environments.

                      </p>
                      <p>

                        <b>Fearlessness and Industriousness:</b> Capricorn's energy is characterized by fearlessness and
                        relentless industriousness, symbolized by the goat's ability to thrive on mountain peaks.

                      </p>
                      <p>

                        <b>Entrepreneurial Spirit:</b> Capricorn resonates with the entrepreneurial spirit, starting with minimal resources and building empires through determination and grit.

                      </p>
                      <p>

                        <b>The Devil:</b> In the Thoth Tarot, Capricorn is associated with the Devil card, representing the
                        initiator, akin to Prometheus bringing the fire of the gods to Earth.
                      </p>
                      <p>
                        <b>Uninhibited Sexuality and Erotic Impulse:</b> Capricorn embodies the male erotic impulse and the uninhibited expression of sexuality, symbolized by the erotic power depicted in the Devil card.

                      </p>
                      <p>
                        <b>Prometheus and Progress:</b> The Archetype of Capricorn is linked to Prometheus, symbolizing progress and the pursuit of excellence in all forms.
                      </p>
                      <p>
                        <b>Frenzied Orgies and Dionysian Influence:</b> Capricorn's energy connects with the Ancient
                        Thracian traditions of frenzied orgies dedicated to Dionysus, embracing chaos and
                        the unknown.
                      </p>

                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/capricorn/capricorn_4img.webp"
                    /> */}
                    <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/capricorn/capricorn_4img.webp`}/> 

                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Defiance of Boundaries:</b> Capricorn defies boundaries, inviting chaos into the creative process and pushing towards the unknown with fearlessness.


                      </p>

                      <p>
                        <b>Symbol of Entrepreneurship and Empire Building:</b> The Archetype of Capricorn serves as a symbol for entrepreneurship and the capacity to build empires through hard work
                        and determination.

                      </p>
                      <p>
                      <b>Call to Embrace Earth's Mysteries:</b> Capricorn encourages embracing the mysteries of the Earth, calling forth the strangeness and novelty of existence into the realm of imagination.
                      </p>

                      <p>
                      <b>Dance to the Rhythm of Pan's Flute:</b> Working under Capricorn's influence involves dancing to the rhythm of Pan's flute, exploring uncharted territories with enthusiasm and courage.

                      </p>

                     
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* =========================================greensec---------------------------------------------               */}

            <div className={styles.green_sec_cmn_main_wrp}>
              <div className={styles.common_width}>
                <Link href="/rota-the-wheel">
                  <div className={styles.green_sec_cmn_sub_wrp}>
                    <h1>The Astrological Tarot association for  <br /> Capricorn is The Devil. See our alchemical ROTA here</h1>
                  </div>
                </Link>
              </div>
            </div>
            {/* ---------------------------------------------------greensec_end=================================== */}

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_capricorn/layman_page38_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_capricorn/layman_page38_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_capricorn/layman_page38_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_capricorn/layman_page38_block4_demo_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_capricorn/layman_page38_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}